<template>
  <router-view />
</template>

<script>


import {onBeforeUnmount, onMounted} from "vue";

export default {
  setup(){
    let observer = null;
    onMounted(() => {
      const targetNode = document.body;
      observer = new MutationObserver(() => {
        const menu = document.querySelectorAll(".p-button.p-splitbutton-menubutton");
        if(menu){
          menu.forEach(elem => {
            if(elem.getAttribute('aria-expanded') == 'true' ){
              document.querySelector('div[data-pc-name=menu]').addEventListener("mouseleave", () => {
                document.body.click();
              });
            }
          })
        }
      });
      observer.observe(targetNode, { childList: true, subtree: true });
    });

    onBeforeUnmount(() => {
      if (observer) observer.disconnect();
    });
    return {

    }
  }
}


</script>

<style>
svg{
  color: #bec3c9 !important;
  background-color: transparent !important;
  stroke: #bec3c9 !important;
}

</style>
